let cartToken; 
const maxSizeInBytes = 5 * 1024 * 1024; 
const fileInput1 = document.getElementById('fileInput1');
const fileInput2 = document.getElementById('fileInput2');
const statusElement = document.getElementById('statusTax');
const statusElementPo = document.getElementById('statusPO');
class cartUploadFile {
    constructor() {
        this.cartForm = document.querySelector('.cartUploadMainDiv');
        this.bindEvents()
        this.removeFilesCartOnLoad();
       
        
    }

    bindEvents() {
        this.validateFileInput("fileInput1", "error-message1", maxSizeInBytes);
    
        this.validateFileInput("fileInput2", "error-message2", maxSizeInBytes);
        this.fetchCartTokenAndUse();
        console.log(cartToken, 'tokennnnn');
        this.cartForm.querySelectorAll('.cartFileUploader').forEach(each=>{
            each.addEventListener('change', (event)=>{
                console.log(event.target);
                
                this.handleFileUpload(event.target.files[0], event.target.id, event);
                this.fileChangeCustom(event)
            })
        })
        this.cartForm.querySelectorAll(".removeFIle").forEach(each=>{
            each.addEventListener('click', (event)=>{
                this.fileRemove(event)
            })
        })
        
        document.querySelector("#paymentMethods").addEventListener('change', (event)=>{this.showFileSelector(event)})
        document.querySelector("#poOrderNumber").addEventListener('input', (event)=>{this.showCheckOutButton(event)})
        document.querySelector('.customCheckoutButton').addEventListener('click', ()=>{this.updatePoNumber()})
    }
    showCheckOutButton(event){
      document.querySelector('.customCheckoutButton').classList.remove("d-none")
      document.querySelector('.checkoutButton').classList.add("d-none")
      if(event.target.value.trim() === "" && this.cartForm.querySelector("#paymentMethods").value === 'Invoice'){
        document.querySelector('.customCheckoutButton').classList.add('disabled')
      }else{
        document.querySelector('.customCheckoutButton').classList.remove('disabled')
      }
      console.log(event.target.value, 'djadjkadajksdalkjdajkd');
      
    }
    showFileSelector(event){

      console.log('triggeeerdkakfafkl');
      // document.querySelector('.customCheckoutButton').classList.remove("d-none")
      // document.querySelector('.checkoutButton').classList.add("d-none")
      if( this.cartForm.querySelector("#paymentMethods").value === 'cards'){
        document.querySelector('.customCheckoutButton').classList.remove('disabled')
        // document.querySelector('.checkoutButton').classList.remove("d-none")
        // this.cartForm.querySelector(".cartFilePickers").classList.add("d-none");
      //   document.querySelectorAll(".removeFIle").forEach(each=>{
      //     each.click()
      // })
        document.querySelector('.checkoutButton').setAttribute('href', `/checkout/`)
       
      
        
    }else{
      console.log('nmnmnmn', document.querySelector('#poOrderNumber').value);
      if(document.querySelector('#poOrderNumber').value === ''){

        document.querySelector('.checkoutButton').setAttribute('href', `/checkout`)
        document.querySelector('.customCheckoutButton').classList.add('disabled')
      }
      // this.cartForm.querySelector(".cartFilePickers").classList.remove("d-none")
      // document.querySelector('.customCheckoutButton').classList.remove("d-none")
      // document.querySelector('.checkoutButton').classList.add("d-none")
    }
    }
    fileChangeCustom(event) {
        if (event.target.value) {
            event.target.closest('.choose-file-parentSecond').querySelector(".removalFile").classList.remove("d-none");
            // event.target.closest('.choose-file-parentSecond').querySelector(".beforeUploadationCustom").classList.add("d-none");
            event.target.closest('.choose-file-parentSecond').querySelector(".choose-file-btnCustom").classList.add("d-none");
        }
        const fileInput = event.target;
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").innerText = fileInput.value
            .split("\\")
            .pop();
        if (fileInput.files.length > 0) {
        }
    }
    fileRemove(event) {
        this.removeFilesCart(event.target.closest('.choose-file-parentSecond').querySelector('.cartFileUploader').id);
        event.target.closest('.choose-file-parentSecond').querySelector(".cartFileUploader").value = "";
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").innerHTML = "";
        event.target.closest('.choose-file-parentSecond').querySelector(".removeFIle").classList.add("d-none");
        // event.target.closest('.choose-file-parentSecond').querySelector(".beforeUploadationCustom").classList.remove("d-none");
        event.target.closest('.choose-file-parentSecond').querySelector(".choose-file-btnCustom").classList.remove("d-none");
    }
    removeFilesCartOnLoad(){
        console.log("DOM fully loaded and parsed");
        const formData = {
          attributes: {}
      };
        formData.attributes.po_order = '';
        formData.attributes.tax_exempt =  '';
        formData.attributes.po_order_number = '';
        formData.attributes.payment_type = '';
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error('Failed to update cart attributes');
              }
              return response.json();
          })
          .then((data) => {
              console.log('Cart updated successfully:', data);
              document.querySelector('#poOrderNumber').value = ''
              document.querySelectorAll(".cartFileUploader").forEach(each=>{
                each.value = ''
            })
            document.querySelector("#paymentMethods").value = 'cards'

          })
          .catch((error) => {
              console.error('Error:', error);
          });
        
      }
    removeFilesCart(id){
        console.log("DOM fully loaded and parsed");
        const formData = {
          attributes: {}
      };
      if(id === 'fileInput1'){
        formData.attributes.po_order = '';
      }else if(id === 'fileInput2'){
        formData.attributes.tax_exempt =  '';
      }
              
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error('Failed to update cart attributes');
              }
              return response.json();
          })
          .then((data) => {
              console.log('Cart updated successfully:', data);
          })
          .catch((error) => {
              console.error('Error:', error);
          });
      }
       validateFileInput(inputId, errorId, maxSizeInBytes, allowedTypes = []) {
        const input = document.getElementById(inputId);
        const errorMessage = document.getElementById(errorId);
    
        input.addEventListener("change", function (event) {
          const file = event.target.files[0]; 
    
          if (file) {
            const fileType = file.type;
            const fileSize = file.size;
    
            if (fileSize > maxSizeInBytes || (allowedTypes.length && !allowedTypes.includes(fileType))) {
              errorMessage.style.display = "block"; 
              event.target.value = ""; 
            } else {
              errorMessage.style.display = "none"; 
            }
          }
        });
      }
      async fetchCartTokenAndUse() {
        try {
          
          const response = await fetch('/cart.json');
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const cartData = await response.json();
           cartToken = cartData.token.split("?key=")[0];
          console.log(cartToken, 'cartToken'); 
          document.querySelector('.checkoutButton').setAttribute('href', `/checkout`)
          // Use the cartToken immediately here
          console.log(cartToken, 'Token used immediately after fetch');
        } catch (error) {
          console.error('Error fetching the Shopify cart:', error);
        }
      }
      async handleFileUpload(file, inputFieldId, event){
        if (!file && inputFieldId === 'fileInput1' && event.target.value === ''){
          console.log(event.target, 'iffffffffff');
          this.removeFilesCart('fileInput1')
          return;
        }else if(!file && inputFieldId === 'fileInput2'  && event.target.value === ''){
          console.log(event.target, 'elseeeee ifffff');
  
          this.removeFilesCart('fileInput2')
          return;
  
        }
        else{
          console.log(event.target, 'elseeeee');
  
          const otherInput = inputFieldId === 'fileInput1' ? fileInput2 : fileInput1;
          console.log(event.target.classList.value, 'eventeventevent');
          const document_type = event.target.classList.contains('poOrder') ? 'po_order' : 'tax_exempt';
        
          otherInput.nextElementSibling.classList.add('disabled')
          otherInput.disabled = true; 
          document.querySelector('.customCheckoutButton').classList.add('disabled')
          document.querySelector('#paymentMethods').setAttribute('disabled','')
          if(inputFieldId==='fileInput1'){
            statusElementPo.classList.remove('d-none')
            statusElementPo.textContent = `Uploading file ...`;
              }else{
                statusElement.classList.remove('d-none')
                statusElement.textContent = `Uploading file ...`;
              }
    
          const formData = new FormData();
          formData.append('file', file);
          formData.append("document_type", document_type);
          formData.append("cart_token", cartToken);
          try {
            const uploadResponse = await fetch('/apps/proxy/api/upload-file', {
              method: 'POST',
              body: formData,
            });
    
            if (uploadResponse.ok) {
              const uploadResult = await uploadResponse.json();
              console.log(`File uploaded successfully from ${inputFieldId}:`, uploadResult.fileUrl);
              if(inputFieldId==='fileInput1'){
                statusElementPo.classList.remove('d-none')
                statusElementPo.textContent = `File uploaded successfully `;
                setTimeout(() => {
                  statusElementPo.classList.add('d-none')
                }, 2000);
              }else{
                statusElement.classList.remove('d-none')
              statusElement.textContent = `File uploaded successfully `;
              setTimeout(() => {
                statusElement.classList.add('d-none')
              }, 2000);
              }
       
              
              const formData = {
        attributes: {}
    };
    
    if (document_type === 'po_order') {
        formData.attributes.po_order = uploadResult.fileUrl;
    } else {
        formData.attributes.tax_exempt = uploadResult.fileUrl;
    }
    // formData.attributes.po_order_number    = document.querySelector("#poOrderNumber").value
    console.log(formData, 'payloadpayload');
    
this.updateCartAttributes(formData, false)
    
            } else {
              throw new Error('File upload failed');
            }
          } catch (error) {
            console.error(`Error from ${inputFieldId}:`, error);
            statusElement.textContent = `Error: ${error.message}`;
          } finally {
            otherInput.nextElementSibling.classList.remove('disabled')
            otherInput.disabled = false; 
            if(document.querySelector('#poOrderNumber').value !== '' || this.cartForm.querySelector("#paymentMethods").value === 'cards') {
              document.querySelector('.customCheckoutButton').classList.remove('disabled');
            }
            document.querySelector('#paymentMethods').removeAttribute('disabled','')
  
          }
        }
  
       

      }
      async updatePoNumber() {
        const formData = {
          attributes: {}
        };
      
        formData.attributes.po_order_number = document.querySelector("#poOrderNumber").value;
      
        if (this.cartForm.querySelector("#paymentMethods").value === 'cards') {
          formData.attributes.payment_type = 'cards';
        } else {
          formData.attributes.payment_type = 'invoice';
        }
      
        const formDataTax = new FormData();
        var tax_exempt;
         if(window.globalVariables.customerTax === true){
          tax_exempt = true
         }
         else{
        if(document.querySelector('#fileInput2').value === '' || document.querySelector('#fileInput2').value === 'undefined'){
           tax_exempt = false
        }else{
           tax_exempt = true
        }
      }
        formDataTax.append('customer_id', window.globalVariables.customer );
        formDataTax.append('tax_exempt', tax_exempt); 
      
        try {
          const uploadResponse = await fetch('/apps/proxy/api/tax-exempt', {
            method: 'POST',
            body: formDataTax,
          });
      
          if (!uploadResponse.ok) {
            throw new Error(`HTTP error! Status: ${uploadResponse.status}`);
          }
      
          const responseData = await uploadResponse.json();
          console.log('Tax exemption status updated successfully:', responseData);
          this.updateCartAttributes(formData, true);
        } catch (error) {
          console.error('Failed to update tax exemption status:', error);
        }
      
        
      
        // Optionally toggle checkout buttons
        // document.querySelector('.customCheckoutButton').classList.add("d-none");
        // document.querySelector('.checkoutButton').classList.remove("d-none");
      }
      

      updateCartAttributes(formData, needCheckout){
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error('Failed to update cart attributes');
              }
              return response.json();
          })
          .then((data) => {
              console.log('Cart updated successfully:', data);
              if(needCheckout === true){
                document.querySelector('.checkoutButton').click()
              }
              // document.querySelector('.checkoutButton').click()
          })
          .catch((error) => {
              console.error('Error:', error);
          });
      }
}
new cartUploadFile();
